import { Flex, Icon, Text } from '@everlywell/ui-kit';
import { Truck, CheckSquare } from '@phosphor-icons/react';
import React from 'react';

/**
 * List of incentives for the product like free shipping, HSA/FSA Available.
 */

export type IncentivesListProps = {
  contentfulFlags?: Queries.pdpContentfulMetadata001Fragment['flags'];
};
const IncentivesList = (props: IncentivesListProps) => {
  const { contentfulFlags } = props;

  const hasFreeShippingFlagEnabled = Boolean(
    contentfulFlags?.find(
      (flag) =>
        flag?.metadata?.metadata_id === 'showFreeShipping' &&
        flag?.value === true,
    ),
  );

  const hasFSAHSAFlagEnabled = Boolean(
    contentfulFlags?.find(
      (flag) =>
        flag?.metadata?.metadata_id === 'showFSAHSA' && flag?.value === true,
    ),
  );

  return (
    <Flex gap={4} justifyContent={'center'}>
      {hasFreeShippingFlagEnabled && (
        <Flex gap={1} alignItems={'center'}>
          <Icon as={Truck} color="tints.darkGrey" boxSize="20px" />
          <Text size="md" color="tints.darkGrey">
            Free shipping
          </Text>
        </Flex>
      )}
      {hasFSAHSAFlagEnabled && (
        <Flex gap={1} alignItems={'center'}>
          <Icon
            as={CheckSquare}
            color="tints.darkGrey"
            width="20px"
            height="20px"
          />
          <Text size="md" color="tints.darkGrey">
            FSA / HSA accepted
          </Text>
        </Flex>
      )}
    </Flex>
  );
};

export default IncentivesList;
